const getters = {
  getTimeOffsSettings: state => state.timeOffsSetting
}

const actions = {
  setTimeOffsSetting ({ commit }, data) {
    commit('setTimeOffsSetting', data)
  },
  addTimeOffsSetting ({ commit }, data) {
    commit('addTimeOffsSetting', data)
  },
  editTimeOffsSetting ({ commit }, data) {
    commit('editTimeOffsSetting', data)
  },
  removeTimeOffsSetting ({ commit }, data) {
    commit('removeTimeOffsSetting', data)
  }
}

const mutations = {
  setTimeOffsSetting (state, data) {
    state.timeOffsSetting = data
  },
  addTimeOffsSetting (state, data) {
    state.timeOffsSetting.push(data)
  },
  editTimeOffsSetting (state, data) {
    state.timeOffsSetting.some(item => {
      if (item.id === data.id) {
        Object.assign(item, data)
        return true
      }
    })
  },
  removeTimeOffsSetting (state, id) {
    state.timeOffsSetting = state.timeOffsSetting.filter(item => item.id !== id)
  }
}

const state = {
  timeOffsSetting: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
